// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TerritoriesInSearchList-wrapper {
  padding-top: 32px;
}
.TerritoriesInSearchList-wrapper [class^=dist_titleStyle] {
  font-size: 20px;
  font-weight: normal;
  margin-bottom: 24px;
}
.TerritoriesInSearchList-wrapper .listWrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 28px;
  column-gap: 28px;
  grid-row-gap: 24px;
  row-gap: 24px;
}
.TerritoriesInSearchList-wrapper .seeMoreCard {
  margin-top: 24px;
}`, "",{"version":3,"sources":["webpack://./src/pages/SearchTerritoriesPage/components/WinninTopicsTab/components/TerritoriesInSearchList/index.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;AACE;EACE,eAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AAEE;EACE,aAAA;EACA,sCAAA;EACA,qBAAA;EAAA,gBAAA;EACA,kBAAA;EAAA,aAAA;AAAJ;AAGE;EACE,gBAAA;AADJ","sourcesContent":[".TerritoriesInSearchList-wrapper {\n  padding-top: 32px;\n\n  [class^='dist_titleStyle'] {\n    font-size: 20px;\n    font-weight: normal;\n    margin-bottom: 24px;\n  }\n\n  .listWrapper {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    column-gap: 28px;\n    row-gap: 24px;\n  }\n\n  .seeMoreCard {\n    margin-top: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
